import React, { useEffect } from 'react'
import Box from '@mui/material/Box';
import panaImg from '../../../assets/pana.svg';

function PrivacyPolicy() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Box>
        <Box component="main" >
          <div className='flex justify-center pt-16 text-[#523880] font-semibold text-30 xl:text-40 max-xs:text-[23px] underline underline-offset-1 decoration-[0.5px] font-sans leading-[40.85px] h-[41px] xl:leading-[54.47px] xl:h-[54px]'>Privacy and Cookies Policies</div>
          <div className='pt-16 pb-28 mx-16 xl:m-auto max-w-[93rem] max-xs:mx-8'>
            <div className='flex justify-between items-center gap-[120px] xl:gap-[220px] max-xs:gap-[10px] max-xs:flex-col-reverse max-xs:w-full max-xs:overflow-hidden'>
              <div className="text-16 font-normal xl:text-20  font-sans leading-[32px] xl:leading-[40px]">
                Welcome to Oye Creators, owned and operated by <strong className='font-bold'>TTL Media Pvt. Ltd. </strong>("Company", "we", "our", or "us"). This Privacy Policy explains how we collect, use, disclose, process, and safeguard your information when you use our website, mobile application, and services.
              </div>
              <div className=' flex justify-end items-end max-xs:justify-center'>
                <img src={panaImg} alt="pana img" className='w-[367px] h-[347.4px] xl:w-[382px] xl:h-[362px] pr-7 xl:pr-[2.85rem] max-xs:w-[250px] max-xs:h-[230px] max-xs:pb-10' />
              </div>
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Information We Collect</div>
            <div className='text-16 font-normal xl:text-20  font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We collect personal and non-personal information including:
              <ul className="list-disc pl-7 marker:text-[#F482C0]  m-0 pt-5 xl:pt-2.5 space-y-5 xl:space-y-2.5">
                <li>
                  <strong className='text-[#F482C0] font-bold text-16 xl:text-20 max-xs:text-xl font-sans leading-[21.79px] xl:leading-[27.24px] '>Personal Information:</strong>
                  <span className='text-16 font-normal xl:text-xl font-sans leading-[21.79px] xl:leading-[27.24px]'> Name, email, phone, social media handles, payment info, etc.</span>
                </li>
                <li>
                  <strong className='text-[#F482C0] font-bold text-16 xl:text-20 font-sans leading-[21.79px] xl:leading-[27.24px]'>
                    Device Data: </strong>
                  <span className='text-16 font-normal xl:text-20 font-sans leading-[21.79px] xl:leading-[27.24px]'>IP address, OS version, crash logs, etc</span>
                </li>
                <li>
                  <strong className='text-[#F482C0] font-bold text-16 xl:text-20 max-xs:text-xl font-sans leading-[21.79px] xl:leading-[27.24px]'>User Content: </strong>
                  <span className='text-16 font-normal xl:text-20 font-sans leading-[21.79px] xl:leading-[27.24px]'>Uploaded videos, chats, and campaign details.</span>
                </li>
              </ul>
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>How We Use Your Information</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We use your data for account management, campaign matchmaking, processing payments, legal compliance, analytics, and to personalize the user experience.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Sharing of Information</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We may share your data with brands, third-party providers, legal authorities, or in the event of a business transfer. No data is sold to third parties.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Your Rights and Controls</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              You may access, correct, delete your data, or withdraw consent. Contact us at contact@oyecreators.com.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Data Retention</div>
            <div className='text-16 font-normal xl:text-20 font-sans pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We retain your data as long as necessary for legal, operational, or service-related reasons. Data is deleted or anonymized when no longer needed.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Security Measures</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We implement encryption, secure storage, and role-based access controls to safeguard your data.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>App Permission</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              Permissions requested may include camera, microphone, location, and storage. Manage permissions in your device settings.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Cookies and Tracking</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We use cookies for session management and analytics. You may adjust settings via your browser.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Children’s Privacy</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We do not knowingly collect data from children under 13. If identified, such data will be deleted.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>International Data Transfers</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              Your data may be processed outside your country of residence with adequate safeguards in place.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Changes to This Policy</div>
            <div className='text-16 font-normal xl:text-20 font-sans  pt-5 xl:pt-2.5 leading-[32px] xl:leading-[46px]'>
              We may update this Privacy Policy. Material changes will be communicated via app or website notifications.
            </div>

            <div className='text-primary-500 text-20 xl:text-30 font-semibold max-xs:text-xl font-sans pt-12 leading-[27.24px] xl:leading-[40.85px]'>Contact Us</div>
            <div className="mt-4 pl-4 border-l-4 border-r-0 border-t-0 border-b-0 border-solid border-[#D9008D]">
              <p className="text-base leading-relaxed text-gray-800">
                TTL Media Pvt. Ltd.
                <br />
                <strong className='text-[#F482C0] font-bold text-16 xl:text-20 font-sans leading-[21.79px] xl:leading-[27.24px]'>Email: </strong>contact@oyecreators.com
                <br />
                <strong className='text-[#F482C0] font-bold text-16 xl:text-20 font-sans leading-[21.79px] xl:leading-[27.24px]'>Website: </strong>https://oyecreators.com
                <br />
                <strong className='text-[#F482C0] font-bold text-16 xl:text-20 font-sans leading-[21.79px] xl:leading-[27.24px]'>Registered Address: </strong>CTS No. 177 p, metro station, S. No. 43/2, near Nal stop, Pandurang Colony, Erandwane, Pune, Maharashtra 411004
              </p>
            </div>
          </div>
        </Box>
      </Box>
    </>
  );
}

export default PrivacyPolicy;
